<template>
  <div>
    <b-collapse id="collapseOpcoesPesquisa" class="mt-2">
      <b-card class="primary-semi p-2">
        <b-row>
            <b-col xs="12" sm="12" md="12" lg="6" xl="6">
                <b-form-group label="Filtrar por:" label-for="filtrarPor" class="text-label">
                    <multiselect
                        v-model="filtrarPor"
                        :show-labels="false"
                        :options="opcoesFiltro"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        placeholder="Selecione"
                        track-by="id"
                        label="filtro"
                    >
                        <template slot="selection" slot-scope="{ values, search, isOpen }">
                            <span
                                class="multiselect__single"
                                v-if="values.length &amp;&amp; !isOpen"
                            >{{ values.length }} selecionado(s)</span>
                        </template>
                    </multiselect>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row v-if="(filtrarPor.filter(e => e.id == 1).length > 0)">
          <b-col xs="12" sm="12" md="6" lg="3" xl="3">
            <b-form-group label="Nº da Dívida:" label-for="numeroDivida" class="text-label">
              <b-form-input v-model="filtro.numeroDivida" type="number" id="numeroDivida" maxlength="8" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="(filtrarPor.filter(e => e.id == 2).length > 0)">
          <b-col xs="12" sm="12" md="6" lg="3" xl="3">
            <b-form-group label="CPF/CNPJ:" label-for="cpfCnpj" class="text-label">
              <the-mask
                id="cpfCnpj"
                class="form-control"
                v-model="filtro.cpfCnpj"
                :mask="['XX.XXX.XXX/XXXX-##', 'XXX.XXX.XXX-XX']"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="(filtrarPor.filter(e => e.id == 3).length > 0)">
          <b-col xs="12" sm="12" md="12" lg="8" xl="8">
            <b-form-group label="Contribuinte:" label-for="contribuinte" class="text-label">
              <b-form-input v-model="filtro.contribuinte" type="text" id="contribuinte" maxlength="100" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="(filtrarPor.filter(e => e.id == 4).length > 0)">
          <b-col xs="12" sm="12" md="12" lg="3" xl="3">
            <b-form-group label="CADICMS:" label-for="cadicms" class="text-label">
              <b-form-input v-model="filtro.cadimcs" type="text" id="cadicms" maxlength="20" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="(filtrarPor.filter(e => e.id == 5).length > 0)">
          <b-col xs="12" sm="12" md="12" lg="6" xl="6">
            <b-form-group label="Comarca:" label-for="comarca" class="text-label">
              <multiselect
                v-model="filtro.comarca"
                :show-labels="false"
                :options="dados.comarcas"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                placeholder="Selecione"
                label="nome"
                track-by="codComarca"
              >
                <template slot="selection" slot-scope="{ values, search, isOpen }">
                  <span
                    class="multiselect__single"
                    v-if="values.length &amp;&amp; !isOpen"
                  >{{ values.length }} selecionado(s)</span>
                </template>
              </multiselect>
            </b-form-group>
          </b-col>
        </b-row>
         <b-row v-if="(filtrarPor.filter(e => e.id == 6).length > 0)">
          <b-col xs="12" sm="12" md="12" lg="3" xl="3">
            <b-form-group label="Tipo de Crédito:" label-for="tipoCredito" class="text-label">
              <multiselect
                v-model="filtro.credito"
                :show-labels="false"
                :options="dados.creditos"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                placeholder="Selecione"
                label="nome"
                track-by="id"
              >
                <template slot="selection" slot-scope="{ values, search, isOpen }">
                  <span
                    class="multiselect__single"
                    v-if="values.length &amp;&amp; !isOpen"
                  >{{ values.length }} selecionado(s)</span>
                </template>
              </multiselect>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="(filtrarPor.filter(e => e.id == 7).length > 0)">
          <b-col xs="12" sm="12" md="12" lg="3" xl="3">
            <b-form-group label="Data de Inscrição (Início):" label-for="dtInscricaoInicio" class="text-label">
              <b-form-input type="date" v-model="filtro.dtInscricaoInicio"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col xs="12" sm="12" md="12" lg="3" xl="3">
            <b-form-group label="Data de Inscrição (Fim)" label-for="dtInscricaoFim" class="text-label">
              <b-form-input type="date" v-model="filtro.dtInscricaoFim"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <hr>
        <b-row>
           <b-col xs="12" sm="12" md="12" lg="12" xl="12">
            <div class="d-flex justify-content-center align-items-center">
              <b-button variant="primary fonte-branca" @click="$emit('filtrar')">
                <i class="fa fa-search"></i> Pesquisar
              </b-button>
              <b-button class="ml-2" variant="secondary" @click="$emit('limparFiltro')">
                <i class="fa fa-eraser"></i> Limpar
              </b-button>
            </div>
           </b-col>
        </b-row>
      </b-card>
    </b-collapse>
  </div>
</template>

<script>
export default {
  props: ["filtro", "dados"],
  data() {
    return {
      filtrarPor: [],
      opcoesFiltro: [
          {
              id: 1,
              filtro: 'Número da Dívida'
          },
          {
              id: 2,
              filtro: 'CPF/CNPJ'
          },
          {
              id: 3,
              filtro: 'Contribuinte'
          },
          {
              id: 4,
              filtro: 'CAD ICMS'
          },
          {
              id: 5,
              filtro: 'Comarca'
          },
          {
              id: 6,
              filtro: 'Tipo de Crédito'
          },
          {
              id: 7,
              filtro: 'Data de Inscrição'
          },
      ],
    }
  }
};
</script>

<style>
</style>
